const AccountIcon = (): JSX.Element => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="16" fill="#F3F3F3" />
    <path
      d="M23.7274 24.4471C23.2716 23.1713 22.2672 22.0439 20.8701 21.2399C19.4729 20.4358 17.7611 20 16 20C14.2389 20 12.5271 20.4358 11.1299 21.2399C9.73276 22.0439 8.72839 23.1713 8.27259 24.4471"
      stroke="#3D3A62"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <circle cx="16" cy="12" r="4" stroke="#3D3A62" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default AccountIcon;
